export const isFrozenRoutes = (pathname: string) => {
    const frozenRoutes = ['/topup', '/capture', '/package-payment']

    return frozenRoutes.includes(pathname)
}
